import React from "react";
import PropTypes from "prop-types";

import {
  Step,
  StepConnector,
  StepIcon,
  StepLabel,
  Stepper,
  withStyles,
} from "@material-ui/core";

const StepperStyleConnector = withStyles({
  active: {
    "& $line": {
      borderColor: "#2185D0",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#2185D0",
    },
  },
  line: {
    borderColor: "#F2F2F3",
  },
})(StepConnector);

const StepIconStyleComponent = withStyles({
  root: {
    width: "24px",
    height: "24px",
    fontSize: "15px",
    color: "#F2F2F3",
  },
  active: {
    fill: "#2185D0",
    "& $text": {
      fill: "#fff",
    },
  },
  completed: {
    fill: "#2185D0",
    "& $text": {
      fill: "#fff",
    },
  },
  text: {
    fontSize: "15px",
    fill: "#969696",
    transform: "translateY(1px)",
  },
})(StepIcon);

export function Breadcrumb({ steps, activeStepIndex }) {
  return (
    <Stepper
      activeStep={activeStepIndex}
      connector={<StepperStyleConnector />}
      alternativeLabel
    >
      {steps.map((label) => {
        return (
          <Step key={label}>
            <StepLabel StepIconComponent={StepIconStyleComponent}>
              {label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
}

Breadcrumb.propTypes = {
  steps: PropTypes.array.isRequired,
  activeStepIndex: PropTypes.number,
};

Breadcrumb.defaultProps = {
  activeStepIndex: 0,
};

export default Breadcrumb;
